import { computed } from 'vue';
import { connectivity } from '@/sync/connectivity';
import { isOfflineBlocked } from '@/utils/domain/connectivityRules';

// Reactive view of src/sync/connectivity.js: the user's manual offline mode included, unlike navigator.onLine.
export function useNetworkStatus() {
	return {
		mode: computed(() => connectivity.mode),
		isOnline: computed(() => connectivity.online),
		isOffline: computed(() => !connectivity.online),
		offlineBlocked: computed(() => isOfflineBlocked(connectivity.mode, connectivity.offlineAllowed)),
	};
}
